import { render } from "./IconBook.vue.js?vue&type=template&id=65d909fc!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconBook.vue?vue&type=template&id=65d909fc"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__